<template>
  <div
    id="CourseCollateral"
    v-loading="loading"
    class=""
    style="padding: 0 20px"
  >
    <el-form ref="form" :model="form" label-width="80px">
      <el-form-item label="类型:">
        <el-radio-group v-model="form.radio">
          <el-radio :label="1">视频</el-radio>
          <el-radio :label="2">音频</el-radio>
          <el-radio :label="4">文档</el-radio>
          <el-radio :label="3">文本</el-radio>
          <el-radio :label="5">音视频链接</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item>
        <el-upload
          class="upload-demo"
          :action="url + '/zkfz/zkolVideoData/saveOrUpdate'"
          :limit="1"
          :before-upload="beforeUpload"
          :on-change="handleChange"
          :file-list="form.fileList"
          style="display: inline-block"
        >
          <el-button size="small" type="primary" style="">点击上传</el-button>

          <!--           <div slot="tip" class="el-upload__tip">只能上传jpg/png文件，且不超过500kb</div>-->
        </el-upload>
      </el-form-item>
      <el-form-item
        ><el-button size="small" type="primary" @click="save" style=""
          >保存</el-button
        ></el-form-item
      >
    </el-form>
    <el-dialog
      title="温馨提示"
      :visible.sync="dialogVisible"
      width="30%"
      :before-close="handleClose"
    >
      <span>课程创建成功</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false" type="primary"
          >返回课程管理</el-button
        >
        <el-button type="primary" @click="dialogVisible = false"
          >进入课时管理</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { confirmMsg } from '@/utils/common'
import * as api from '@/api/courseware/course'

export default {
  name: 'CourseCollateral',
  components: {},
  data() {
    return {
      loading: false,
      form: {
        radio: '',
        fileList: [],
      },
      dialogVisible: false,
      file: '',
    }
  },
  methods: {
    // 获取数据
    getList() {
      // this.loading = true
    },

    save() {
      let formdata = new FormData()
      formdata.append('videoTitle', this.$route.query.videoTitle)
      formdata.append('learnTypeId', this.$route.query.learnTypeId)
      formdata.append('courseId', this.$route.query.courseId)
      formdata.append('courseCode', this.$route.query.courseCode)
      formdata.append('ctime', this.$route.query.ctime)
      formdata.append('mhmId', this.$route.query.mhmId)
      formdata.append('uid', this.$route.query.uid)
      formdata.append('giveMhmIds', this.$route.query.giveMhmIds)
      formdata.append('cover', this.$route.query.cover)
      formdata.append('videoBinfo', this.$route.query.videoBinfo)
      formdata.append('videoIntro', this.$route.query.videoIntro)
      formdata.append('isCharge', this.$route.query.isCharge)
      formdata.append('isMount', this.$route.query.isMount)
      formdata.append('isVerify', this.$route.query.isVerify)
      formdata.append('vPrice', this.$route.query.vPrice)
      formdata.append('tPrice', this.$route.query.tPrice)
      formdata.append('term', this.$route.query.term)
      formdata.append('listingtime', this.$route.query.listingtime)
      formdata.append('uctime', this.$route.query.uctime)
      formdata.append('start', this.$route.query.start)
      formdata.append('overTime', this.$route.query.overTime)
      formdata.append('endTime', this.$route.query.endTime)
      formdata.append('isBest', this.$route.query.isBest)
      formdata.append('bestSort', this.$route.query.bestSort)
      formdata.append('isOrder', this.$route.query.isOrder)
      formdata.append('showPlace', this.$route.query.showPlace)
      formdata.append('fileType', this.form.radio)
      formdata.append('file', this.file)
      api.addCourseDetail(formdata).then(({ data }) => {
        if (data.code == 100000) {
          this.$message({ type: 'success', message: '添加成功' })
          // this.dialogVisible = true
        }
      })
    },

    handleClose() {
      this.dialogVisible = false
    },

    handleChange(file) {
      this.file = file.raw
    },

    beforeUpload(file) {
      if (this.form.radio == '1') {
        //视频
        const isJPG = file.type === 'video/mp4'

        if (!isJPG) {
          this.$message.error('上传文件只能是 mp4 类型!')
        }
        return isJPG
      } else if (this.form.radio == '2') {
        //音频
        const isJPG = file.type === 'audio/mpeg'

        if (!isJPG) {
          this.$message.error('上传文件只能是 mp3 类型!')
        }
        return isJPG
      } else if (this.form.radio == '4') {
        //文档
        const isJPG = file.type == 'application/msword'
        const isJPG1 =
          file.type ==
          'application/vnd.openxmlformats-officedocument.wordprocessingml.document'
        const isJPG2 = file.type == 'application/pdf\tPortable Document Format'
        const isJPG3 = file.type == 'application/vnd.ms-excel'
        const isJPG4 =
          file.type ==
          'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
        const jsJPG5 = 'application/pdf'
        if (!isJPG && !isJPG1 && !isJPG2 && !isJPG3 && !isJPG4 && !jsJPG5) {
          this.$message.error('上传文件只能是excel、pdf、word类型!')
        }

        return isJPG || isJPG1 || isJPG2 || isJPG3 || isJPG4 || jsJPG5
      } else if (this.form.radio == '3') {
        //文本
        const isJPG = file.type === 'text/plain'

        if (!isJPG) {
          this.$message.error('上传文件只能是 txt 类型!')
        }
        return isJPG
      }
    },
  },
  created() {
    this.getList()
  },
  computed: {
    getUId() {
      return localStorage.getItem('uid') 
    },
    url() {
      let url = window.location.protocol + '//' + window.location.host
      if (window.location.host == 'localhost:5001') {
        url = 'http://gz.hnjk.net'
      }
      return url
    },
  },
}
</script>

<style lang="scss" scoped>
/deep/.el-tabs__item {
  font-size: 12px;
}
/deep/.el-tabs__item {
  padding: 0 10px !important;
}
/deep/.el-pagination.is-background .btn-next,
/deep/.el-pagination.is-background .btn-prev,
/deep/.el-pagination.is-background .el-pager li {
  background-color: #e2e8f4;
}
/deep/.el-pagination.is-background .el-pager li:not(.disabled).active {
  background-color: #265480;
}
</style>
<style>
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}
.avatar {
  width: 178px;
  height: 178px;
  display: block;
}
.ql-editor {
  min-height: 300px;
}
.el-tabs__item {
  font-size: 14px !important;
}
</style>
